import React, { useEffect, useState } from 'react';
import { Drawer, Col } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Button } from 'components/Button';
import AnimatedCustomSelect from 'components/AnimatedSelectComp';
import ConfirmLeaveEdit from 'pages/userManagementV3/localComponent/confirmLeaveEdit';
import { Heading } from 'components/Typography';

const EditApproversDrawer = ({ visible, onClose, selectedUserId, searchUsers, searchedTeachers, postEditApprovers, setPageLoader, leaveDetails_V3, getLeavesData ,isMonth,isYear}) => {
    const teacherMap = {};
    searchedTeachers.forEach((item) => {
        teacherMap[item.value] = item.id;
    });

    const [searchValues, setSearchValues] = useState(['']);
    const [selectedApprovers, setSelectedApprovers] = useState([null]);
    const [updateLoader, setUpdateLoader] = useState(false);
    const [confirmVisible, setConfirmVisible] = useState(false);

    useEffect(() => {
        if (visible && leaveDetails_V3?.allApprovers) {
            const initialSearchValues = leaveDetails_V3.allApprovers.map(approver => approver.name || '');
            const initialSelectedApprovers = leaveDetails_V3.allApprovers.map(approver => approver.id || null);
            setSearchValues(initialSearchValues);
            setSelectedApprovers(initialSelectedApprovers);
        } else if (!visible) {
            setSearchValues(['']);
            setSelectedApprovers([null]);
        }
    }, [visible, leaveDetails_V3?.allApprovers]);

    const handleUpdate = () => setConfirmVisible(true);

    const handleConfirm = () => {
        setConfirmVisible(false);
        const approverParams = {
            userId: selectedUserId,
            approver1: selectedApprovers[0],
            approver2: selectedApprovers[1],
            approver3: selectedApprovers[2],
        };
        setUpdateLoader(true);
        postEditApprovers(approverParams, () => {
            setUpdateLoader(false);
            setPageLoader(true);
            onClose();
            const params={
                userId:selectedUserId,
                year:isYear,
                month:isMonth
            }
            getLeavesData(params, () => getLeavesTypes( () => setPageLoader(false)))
            
        });
    };

    const filteredOptions = () => searchedTeachers.filter(item => item.id !== selectedUserId && item.id !== 2586);

    const handleAddApprover = () => {
        if (searchValues.length < leaveDetails_V3?.level) {
            setSearchValues([...searchValues, '']);
            setSelectedApprovers([...selectedApprovers, null]);
        }
    };

    const handleRemoveApprover = () => {
        if (searchValues.length > 1) {
            setSearchValues(searchValues.slice(0, -1));
            setSelectedApprovers(selectedApprovers.slice(0, -1));
        }
    };

    const canAddApprover = searchValues.length < leaveDetails_V3?.level;
    const canRemoveApprover = searchValues.length > 1;

    return (
        <Drawer
        // title={<span>Approvers</span>}
            placement="right"
            closable={false}
            onClose={onClose}
            visible={visible}
            // closeIcon={<CloseOutlined style={{ position: 'absolute', top: '16px', right: '16px', fontSize: '16px' }} />}
            headerStyle={{ borderBottom: 'none' }}
            width={'33%'}
        >
            <div className='drawer-title'>
            <Heading>Approvers</Heading>
                <div><CloseOutlined style={{ color: '#AEAEAE' }} onClick={onClose} /></div>
            </div>
            <div className='p-20'>
                <Col>
                    {searchValues.map((searchValue, index) => (
                        searchValue || index === 0 || (index < leaveDetails_V3?.level && searchValues[index - 1]) ? (
                            <AnimatedCustomSelect
                                key={index}
                                label={` Approver ${index + 1}`}
                                options={filteredOptions().map(item => ({ label: item.value, value: item.value }))}
                                handleSelectChange={(value) => {
                                    const updatedSearchValues = [...searchValues];
                                    const updatedSelectedApprovers = [...selectedApprovers];
                                    updatedSearchValues[index] = value;
                                    updatedSelectedApprovers[index] = teacherMap[value];
                                    setSearchValues(updatedSearchValues);
                                    setSelectedApprovers(updatedSelectedApprovers);
                                }}
                                value={searchValue}
                                isSelected={!!searchValue}
                                allowClear
                            />
                        ) : null
                    ))}
                </Col>
                <div className='r-c-fe m-t-20' >
                {canAddApprover && (
                        <Button style={{ color: '#594099' }} onClick={handleAddApprover} type='link' disabled={!canAddApprover}>ADD NEW</Button>
                    )}
                {canRemoveApprover && (
                    <Button  style={{ padding: '0px'}} onClick={handleRemoveApprover} type='delete' disabled={!canRemoveApprover}>REMOVE</Button>
                )}                
                </div>
                <div  className='bottom0 absolute full-width r-c-sb p-20' >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '90%' }}>
                        <Button onClick={() => onClose()} type='secondary'>CANCEL</Button>
                        <Button loading={updateLoader} onClick={handleUpdate} type='primary'>SAVE</Button>
                    </div>
                </div>
            </div>
            <ConfirmLeaveEdit
                visible={confirmVisible}
                onClose={() => setConfirmVisible(false)}
                onDelete={handleConfirm}
                deleteLoader={updateLoader}
                message="Are you sure you want to update the approvers?"
            />
        </Drawer>
    );
};

export default EditApproversDrawer;
